import { render, staticRenderFns } from "./newVersionEvent.vue?vue&type=template&id=3c6c4881"
import script from "./newVersionEvent.vue?vue&type=script&lang=js"
export * from "./newVersionEvent.vue?vue&type=script&lang=js"
import style0 from "./newVersionEvent.vue?vue&type=style&index=0&id=3c6c4881&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports